import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpClient,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Observable } from "rxjs/internal/Observable";
import { throwError } from "rxjs/internal/observable/throwError";
import { retry, catchError, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthService } from "../auth/services/auth.service";

@Injectable({
  providedIn: "root",
})
export class HttpErrorInterceptor implements HttpInterceptor {
  isNoInternet = false;
  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private aRoute: Router,
    private _snackBar: MatSnackBar
  ) {}

  saveError(data) {
    this.http
      .post<any>(
        `${environment.configUrl}Configuration/InsertApplicationErrorLog`,
        data
      )
      .subscribe(
        (resData) => {
          if (resData.success) {
            console.log("error saved");
          } else {
            console.log("failed to save error");
          }
        },
        (err) => {
          console.log("failed to save error");
        }
      );
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (window.navigator.onLine) {
      if (this.isNoInternet) {
        this._snackBar.dismiss();
      }
      if (
        request.url.includes("/Configuration/InsertApplicationErrorLog") ||
        request.url.includes("SocketID") ||
        request.url.includes("/Referral/ViewReferralDocs") ||
        request.url.includes("/Staff/GenerateRotaPDF") ||
        request.url.includes("/CQCFileStructure/GenerateCQCPolicyPDF")
      ) {
        return next.handle(request);
      } else {
        return next.handle(request).pipe(
          tap((res: HttpResponse<any>) => {
            if (
              res instanceof HttpResponse &&
              res.body &&
              !res.body.success &&
              !res.body.results &&
              !res.body.addresses &&
              !res.body.Items
            ) {
              if (res.body.message === "jwt expired") {
                this._snackBar.open(
                  "Your Session has been expired. Please log back in to continue.",
                  "Ok",
                  {
                    duration: 2160000,
                    panelClass: ["pink-background", "font2"],
                    horizontalPosition: "right",
                    verticalPosition: "top",
                  }
                );
                this._snackBar._openedSnackBarRef.onAction().subscribe(() => {
                  localStorage.clear();
                  this.auth.loginStatusChanges();
                  this.aRoute.navigate(["auth", "login"]);
                });
              } else {
                const data = {
                  ApplicationErrorData: JSON.stringify({
                    ErrorMessage: JSON.stringify(res.body.error),
                    ErrorNumber: res.status,
                    TechnicalErrorMessage: JSON.stringify(res.body.error),
                    APIName: request.url,
                    StaffID: this.auth.staffId,
                    PatientID: 0,
                    VersionNumber: environment.Version,
                    IsFromWebsite: 0,
                    IsFromAdmin: 1,
                    PageName: this.aRoute.url,
                  }),
                };
                this.saveError(data);
              }
              return res;
            } else {
              return res;
            }
          }),
          catchError((error: HttpErrorResponse) => {
            console.log("error in catch",error)
            let errorMessage = "";
            if (error.error instanceof ErrorEvent) {
              // client-side error
              errorMessage = error.error.message;
            } else {
              // server-side error
              errorMessage = error.message;
            }

            if (
              error.error.message.toLowerCase() === "No token provided" ||
              error.error.message.toLowerCase() ===
                "No token and UserID Matching" ||
              error.error.message.search(/expired/i)
            ) {
              const data = {
                ApplicationErrorData: JSON.stringify({
                  ErrorMessage: error.error.message,
                  ErrorNumber: error.status,
                  TechnicalErrorMessage: error.message,
                  APIName: request.url,
                  StaffID: this.auth.staffId,
                  PatientID: 0,
                  VersionNumber: environment.Version,
                  IsFromWebsite: 0,
                  IsFromAdmin: 1,
                  PageName: this.aRoute.url,
                }),
              };
              this.saveError(data);
            }
            if (errorMessage !== "") {
              const data = {
                ApplicationErrorData: JSON.stringify({
                  ErrorMessage: error.error.message,
                  ErrorNumber: error.status,
                  TechnicalErrorMessage: error.message,
                  APIName: request.url,
                  StaffID: this.auth.staffId,
                  PatientID: 0,
                  VersionNumber: environment.Version,
                  IsFromWebsite: 0,
                  IsFromAdmin: 1,
                  PageName: this.aRoute.url,
                }),
              };
              this.saveError(data);
            }

            return throwError(errorMessage);
          })
        );
      }
    } else {
      this._snackBar.open("No Internet Connection", "", {
        duration: 2160000,
        panelClass: ["red-background", "font2", "text-white"],
        horizontalPosition: "right",
        verticalPosition: "top",
      });
      this.isNoInternet = true;
    }
  }
}
